// extracted by mini-css-extract-plugin
export default {"root":"FD4Gf","text-block":"_3PDEF","textBlock":"_3PDEF","prefix":"_3v1lM"};